import Vue from 'vue';
import Enum from 'enum';

/**
 * Global API Event Bus
 */

class _BusyUIBus {
  constructor() {
    this.bus = new Vue();
    this.events = new Enum([
      'UIBusy',
      'UICalm',
    ])
  }

  /**
   * Emits the UIBusy event with the vue as the origin
   *
   * @param vue
   */

  emitBusy(vue) {
    this.emit(this.events.UIBusy, vue);
  }

  /**
   * Emits the UICalm event with the vue as the origin
   *
   * @param vue
   */

  emitCalm(vue) {
    this.emit(this.events.UICalm, vue);
  }

  /**
   * Emits an event defined by the events Enum.
   *
   * @param event
   * @param vue
   */

  emit(event, vue) {
    this.bus.$emit(event.toString(), vue);
  }
}

export const BusyUIBus = new _BusyUIBus();
